import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { environment } from '../../../environments/environment';
import { PostulacionesService } from '../../services/postulaciones/postulaciones.service';
import { AyudaMedicaService } from '../../services/ayuda-medica/ayuda-medica.service';
import { ProductosService } from '../../services/productos/productos.service';
import Swal from 'sweetalert2';
import { TiposService } from '../../services/tipos/tipos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { DialogTipoRechazo } from '../common/postulacion-rechazar.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { Beneficiario } from '../../models/beneficiario/beneficiario.model';
import { AyudaMedica } from 'src/app/models/ayudamedica/ayudaMedica.model';
import { DocumentoAyudaMedica } from 'src/app/models/ayudamedica/documentoAyudaMedica.model';
import { isNullOrUndefined } from 'util';
import { isNull } from 'util';
import { NgForm } from '@angular/forms';
declare const Rut: any;

export interface DialogData {
    archivo: any[];
    archivoTest: any;
    archivoTest2: any;
    archivoTest3: any;
    archivoTest4: any;
    archivoTest5: any;
    archivoTest6: any;
    idPostulacion: any;
    idUsuario: any;
    beneficiario: string;
    datoBeneficiario: string;
    observacion: string;
    stringTipoEvento: string;
    eventos: any;
    tipoSistema: any;
    sistemaSalud: any;
    tipoProteccion: any;
    IdOpcionNinguna: number;
    tiposDocumento: any;
    proteccion: any;
    tipoDocumento: any;
    sistema: any;
    montoMinimoActivo: any;
    montoMinimoPasivo: any;
    totalconDescuento: number;
    porcentaje: number;
    valorCopago1: number;
    valorCopago2: number;
    valorCopago3: number;
    totalPagar1: number;
    totalPagar2: number;
    postulantes: any[];
    carga: boolean;
    otro: boolean;
    otroProteccionSalud: boolean;
    deshabilitado: boolean;
    deshabilitadoObs: boolean;
    presionaEditar: boolean;
    mostrarDocumento: boolean;
    recarga: boolean;
    tipoEvento: any;
    scales: any
    mostrarEditar: string;
    rol: string;
    disponiblePago: any;
    totalPagar: any;
    totalCopago: any;
    montoCopago: any;
    porcentajeRebaja: any;
    sumatoriaMontoCopago: number;
    mostrarAprobarButton: any;
    diasDiferencia: any;
    topeMaximo: any;
    topeMaximoMedico: any;
    topeMaximoDental: any;
    sumatoriaCupoOcupado:  any;
    idCarga: any;
    mostrarTitularCarga: boolean;
    mostrarBeneficiarios: boolean;
    config: any;
    beneficiarios: Beneficiario[];
    ayudaMedica: AyudaMedica[];
    ayudaMedicaTemp: AyudaMedica[];
    documentosAyuda: DocumentoAyudaMedica[];
    documentosAyudaEdit: DocumentoAyudaMedica;
    cantidadArchivos: any;
}

@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: '../../pages/postulaciones-salud/postulacion-ayudamedica-validar.html',
    styleUrls: ['../../pages/postulaciones-salud/postulaciones-ayudamedica.component.css'],
})
export class DialogEditPostulacionAyudaMedica {
    constructor(public dialogRef: MatDialogRef<DialogEditPostulacionAyudaMedica>,
        private ayudaService: AyudaMedicaService,
        private postulacionesService: PostulacionesService,
        private productosService: ProductosService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog,) {
        let vm = this
        this.data.recarga = false
        this.data.otro = false
        this.data.archivo = []
        vm.data.rol = localStorage.getItem('rol')
        this.data.otroProteccionSalud = false
        this.data.mostrarDocumento = false
        this.data.tiposDocumento = ['BONO', 'REEMBOLSO', 'BOLETA/FACTURA/VOUCHER'];
        vm.data.porcentaje = 0;
        this.data.documentosAyudaEdit = new DocumentoAyudaMedica();
        this.data.cantidadArchivos = 1;
        this.data.config = { itemsPerPage: 5, currentPage: 1, totalItems: 5, indexInicial: 0, indexMaximo: 5 }
        this.ayudaService.traeTipoEvento().then(eventos => this.data.eventos = eventos).catch(error => console.log(error))
        this.ayudaService.traeProteccionSalud().then(proteccion => this.data.proteccion = proteccion).catch(error => console.log(error))
        this.ayudaService.traeSistemaSalud().then(sistema => this.data.sistema = sistema).catch(error => console.log(error))
        this.productosService.obtieneProductos().then
            (
                productos => productos[10].parametros.map(parametro => {

                    if (parametro.descripcion == 'DIAS_MAXIMOS_DIFERENCIA_FECHA_DOCUMENTO') {
                        vm.data.diasDiferencia = parametro.valor
                    }
                    if (parametro.descripcion == 'TOPE_MAXIMO') {
                        vm.data.topeMaximo = parametro.valor
                    } 
                    if (parametro.descripcion == 'TOPE_MAXIMO_MEDICO') {
                        vm.data.topeMaximoMedico = parametro.valor
                    }
                    if (parametro.descripcion == 'TOPE_MAXIMO_DENTAL') {
                        vm.data.topeMaximoDental = parametro.valor
                    }
                    if (parametro.descripcion == 'MONTO_MINIMO_ACTIVO') {
                        vm.data.montoMinimoActivo = parametro.valor
                    }

                    if (parametro.descripcion == 'MONTO_MINIMO_PASIVO') {
                        vm.data.montoMinimoPasivo = parametro.valor
                    }
                    if (parametro.descripcion == 'PORCENTAJE') {
                        vm.data.porcentaje = parametro.valor
                    }
                    if (parametro.descripcion == 'VALOR_COPAGO1') {
                        vm.data.valorCopago1 = parametro.valor
                    }
                    if (parametro.descripcion == 'VALOR_COPAGO2') {
                        vm.data.valorCopago2 = parametro.valor
                    }
                    if (parametro.descripcion == 'VALOR_COPAGO3') {
                        vm.data.valorCopago3 = parametro.valor
                    }
                    if (parametro.descripcion == 'TOTAL_PAGAR1') {
                        vm.data.totalPagar1 = parametro.valor
                    }
                    if (parametro.descripcion == 'TOTAL_PAGAR2') {
                        vm.data.totalPagar2 = parametro.valor
                    }

                })
            )
            .catch(error => console.log(error))

            let idCarga=0
            if(vm.data.idCarga)
                idCarga= vm.data.idCarga
    
            let idUsuario=0
            if(vm.data.idUsuario)
                idUsuario= vm.data.idUsuario
            
            let idPostulacion=0
            if(vm.data.idPostulacion)
                idPostulacion= vm.data.idPostulacion

            let tipoEvento=27
             if(vm.data.tipoEvento)
               tipoEvento= vm.data.tipoEvento    

            this.ayudaService.cupoSumatoriaOcupado(idUsuario, idCarga,idPostulacion,tipoEvento).then(
                (sumatoriaCupoOcupado) => {
                    vm.data.sumatoriaCupoOcupado=  sumatoriaCupoOcupado                                      
                }
            ).catch(error => {             
                console.log(error)
            })       

    }

    onRechazarClick(): void {
        let vm = this


        let dataRechazo: any =
        {
            idPostulacion: this.data.idPostulacion, tiposRechazo: [], tipoRechazo: '', //email: this.data.email,
            //nombreCompleto: this.data.nombreCompleto, 
            nombreProducto: 'AYUDAMEDICA'
        }

        this.postulacionesService.motivoRechazo(3).then(rechazos => {
            dataRechazo.tiposRechazo = rechazos
        })
            .catch(error => {

                console.log(error)
            });

        const dialogRechazo = this.dialog.open(DialogTipoRechazo, { width: '50%', data: dataRechazo })

        dialogRechazo.afterClosed().subscribe(() => {

            vm.data.recarga = true
            vm.dialogRef.close()
        })
    }

    onAprobarClick() {

        let vm = this
        let titular = true
        let rut = ''
        let idUsuarioSesion = localStorage.getItem("idUsuario")

        let existenEventosDiferentes = false
        for (let i = 0; i < vm.data.documentosAyuda.length; i++) {
            for (let j = 0; j < i; j++) {
                if (vm.data.documentosAyuda[i].idTipoEvento != vm.data.documentosAyuda[j].idTipoEvento) {
                    existenEventosDiferentes = true
                }
            }
        }

        if (existenEventosDiferentes) {
            vm.openAlertDialog('El tipo de evento no debe ser distinto entre los diferentes documentos', 'btn-danger')
            Swal.close();
            return false;
        }

        if(vm.data.totalPagar>vm.data.topeMaximo) {
            this.openAlertDialog('El total no debe super al máximo permitido:'+vm.data.topeMaximo, 'btn-danger')
            Swal.close();
            return false;
        }

        if (!isNullOrUndefined(this.data.postulantes) && !isNullOrUndefined(this.data.postulantes[0].tipoCarga)) {

            rut = this.data.postulantes[0].rut
            titular = false
        } else {
            let limpiarRut = this.data.beneficiario.split("(");
            let obtenerRut = limpiarRut[1].split("-");
            rut = obtenerRut[0]
        }
        let fechaMinima = new Date()
        fechaMinima.setDate(fechaMinima.getDate() - this.data.diasDiferencia)


        this.postulacionesService.sinPostulacionesVigentes(2, rut, titular).then
            (
                response => {

                    if (Object.values(response).length > 1) {
                        vm.openAlertDialog('El rut ya tiene una solicitud de Ayuda Médica ingresada, favor revisar.', 'btn-danger')
                        Swal.close();
                        return
                    }


                    const dialogRef = this.dialog.open(ConfirmationDialog, {
                        data: { message: '¿Esta seguro de aprobar la postulación?', buttonText: { ok: 'Si', cancel: 'No' } }
                    })

                    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
                        if (confirmed) {
                            Swal.fire({
                                allowOutsideClick: false,
                                icon: 'info',
                                text: 'Cargando...'
                            });
                            Swal.showLoading();
                            vm.postulacionesService.cambiarEstadoPostulacion(vm.data.idPostulacion, "DISPONIBLE PARA PAGO", idUsuarioSesion).then
                                (
                                    () => {
                                        vm.data.recarga = true
                                        vm.dialogRef.close()
                                        Swal.close();
                                        vm.openAlertDialog('La postulación se ha aprobado exitosamente.', 'btn-success')
                                    }
                                )
                                .catch
                                (
                                    error => {
                                        Swal.close();
                                        console.log(error)
                                        vm.dialogRef.close()
                                        vm.openAlertDialog('La postulación no se ha podido aprobar.', 'btn-danger')
                                    }
                                )
                        }
                    })


                }
            )
            .catch
            (
                () => {
                    /* if(fechaIngresada < fechaMinima || fechaIngresada > new Date())
                     {
                         Swal.close();
                         this.openAlertDialog('La fecha de certificado ingresada no cumple con los estándares establecidos. Favor revisar.', 'btn-dark')
                         
                     }else{ */
                    const dialogRef = this.dialog.open(ConfirmationDialog, {
                        data: { message: '¿Esta seguro de aprobar la postulación?', buttonText: { ok: 'Si', cancel: 'No' } }
                    })

                    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
                        if (confirmed) {
                            Swal.fire({
                                allowOutsideClick: false,
                                icon: 'info',
                                text: 'Cargando...'
                            });
                            Swal.showLoading();
                            vm.postulacionesService.cambiarEstadoPostulacion(vm.data.idPostulacion, "DISPONIBLE PARA PAGO", idUsuarioSesion).then
                                (
                                    () => {
                                        vm.data.recarga = true
                                        vm.dialogRef.close()
                                        Swal.close();
                                        vm.openAlertDialog('La postulación se ha aprobado exitosamente.', 'btn-success')
                                    }
                                )
                                .catch
                                (
                                    error => {
                                        Swal.close();
                                        console.log(error)
                                        vm.dialogRef.close()
                                        vm.openAlertDialog('La postulación no se ha podido aprobar.', 'btn-danger')
                                    }
                                )
                        }
                    })
                }

                // }
            )

    }

    onEditarClick(): void {
        this.data.deshabilitado = false
        // *ngIf="this.data.rol == 'ROLE_ADMINISTRADOR' || this.data.rol == 'ROLE_ASISTENTE_SOCIAL' || this.data.rol == 'ROLE_COORDINADOR'"
        if (this.data.rol == 'ROLE_ADMINISTRADOR' || this.data.rol == 'ROLE_ASISTENTE_SOCIAL' || this.data.rol == 'ROLE_COORDINADOR') {
            this.data.deshabilitadoObs = false
        }

        this.data.presionaEditar = true
    }

    onCancelarClick(): void { this.dialogRef.close() }

    onDescargarArchivosClick(postulacionId: any) {
        let vm = this

        vm.postulacionesService.traeArchivos(postulacionId).then
            (
                (archivos: any) => {
                    archivos.forEach(archivo => {
                        var fileURL = `${environment.urlBlob}/${archivo.url}`
                        window.open(fileURL, '_blank')
                    })

                }
            )
            .catch
            (
                error => {
                    console.log(error)
                    vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
                }
            )
    }


    onGuardarClick() {
        let vm = this
        let existenEventosDiferentes = false
        for (let i = 0; i < vm.data.documentosAyuda.length; i++) {
            for (let j = 0; j < i; j++) {
                if (vm.data.documentosAyuda[i].idTipoEvento != vm.data.documentosAyuda[j].idTipoEvento) {
                    existenEventosDiferentes = true
                }
            }
        }

        if (existenEventosDiferentes) {
            vm.openAlertDialog('el tipo de evento no debe ser distinto entre los diferentes documentos', 'btn-danger')
            Swal.close();
            return false;
        }

       

        if(vm.data.totalPagar>vm.data.topeMaximo) {
            this.openAlertDialog('El total no debe super al máximo permitido:'+vm.data.topeMaximo, 'btn-danger')
            Swal.close();
            return false;
        }


        let idUsuarioSesion = localStorage.getItem("idUsuario")
        let idUsuario = this.data.idUsuario
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();
        let fechaMinima = new Date()
        this.ayudaService.editarAyudaMedica(vm.data, idUsuario, idUsuarioSesion).then
            (
                () => {
                    vm.data.recarga = true
                    vm.dialogRef.close()
                    Swal.close();
                    vm.openAlertDialog('La postulación se ha guardado exitosamente.', 'btn-success')
                }
            )
            .catch
            (
                (error: any) => {
                    if (error.status == 406) {
                        vm.openAlertDialog('El afiliado ya tiene una solicitud para el mismo rut de hijo.', 'btn-danger')
                        Swal.close();
                    } else if (error.status == 402) {
                        vm.openAlertDialog('Documento emitido en periodo de carencia.', 'btn-danger')
                        Swal.close();
                    } else if (error.status == 412) {
                        vm.openAlertDialog('Beneficio con fecha de evento anterior a la fecha de afiliación.', 'btn-danger')
                        Swal.close();
                    } else {
                        vm.dialogRef.close()
                        vm.openAlertDialog('La postulación no se ha logrado guardar.', 'btn-danger')
                        Swal.close();
                    }

                }
            )
    }


    editarAyudaMedicaPostGuardarDocumento() {
        let vm = this
        let existenEventosDiferentes = false
        let idUsuarioSesion = localStorage.getItem("idUsuario")
        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        Swal.showLoading();
        let fechaMinima = new Date()
        let dataTemp = vm.data;
        this.ayudaService.editarAyudaMedicaPostGuardarDocumento(dataTemp, idUsuarioSesion).then
            (
                () => {
                    //    vm.data.recarga = true
                    //   vm.dialogRef.close()
                    Swal.close();
                    //   vm.openAlertDialog('La postulación se ha guardado exitosamente.', 'btn-success')
                }
            )
            .catch
            (
                (error: any) => {
                    if (error.status == 406) {
                        vm.openAlertDialog('El afiliado ya tiene una solicitud para el mismo rut de hijo.', 'btn-danger')
                        Swal.close();
                    } else if (error.status == 402) {
                        vm.openAlertDialog('Documento emitido en periodo de carencia.', 'btn-danger')
                        Swal.close();
                    } else if (error.status == 412) {
                        vm.openAlertDialog('Beneficio con fecha de evento anterior a la fecha de afiliación.', 'btn-danger')
                        Swal.close();
                    } else {
                        vm.dialogRef.close()
                        vm.openAlertDialog('La postulación no se ha logrado guardar.', 'btn-danger')
                        Swal.close();
                    }

                }
            )
    }

    esconderBeneficiarios(parentesco: string) {
        let vm = this
        this.data.mostrarBeneficiarios = false;

        if (parentesco == 'TITULAR' && vm.data.scales == false) {
            this.data.mostrarBeneficiarios = true;
        } else {
            this.data.mostrarBeneficiarios = false;
        }
    }

    onMuestraDocumento(idDocumento: any, idAyudaMedica: any) {
        let vm = this
        this.data.mostrarDocumento = true;
        vm.postulacionesService.traeDocumento(idDocumento).then
            (
                (response: any) => {

                    vm.data.documentosAyudaEdit = response;
                    vm.data.documentosAyudaEdit.fechaDocumento = response.fechaDocumento
                    vm.data.documentosAyudaEdit.fechaDocumento = response.fechaDocumento.split('-')[2] + '-' + response.fechaDocumento.split('-')[1] + '-' +
                        response.fechaDocumento.split('-')[0]
                    if (response.rutPrestador) {
                        vm.data.documentosAyudaEdit.rutPrestador = response.rutPrestador + '-' + response.dvPrestador;
                    }
                    if(vm.data.documentosAyudaEdit.proteccionSaludString){
                        let proteccionSaludString = vm.data.documentosAyudaEdit.proteccionSaludString.split(",");
                        let proteccionSaludArrayNumber: Array<number> = []
                        for (let i = 0; i < proteccionSaludString.length; i++) {
                            proteccionSaludArrayNumber.push(Number(proteccionSaludString[i]));
                        }
                        if (proteccionSaludArrayNumber.length > 0) {
                            vm.data.documentosAyudaEdit.proteccionSaludArray = proteccionSaludArrayNumber;
                        } else {
                            vm.data.documentosAyudaEdit.proteccionSaludArray = [0]
                        }
                    }
                   
                   
                    if (response.otroSistemaSalud) {
                        vm.data.otro = true
                    }
                    if (response.otroProteccion) {
                        vm.data.otroProteccionSalud = true
                    }
                }

            )
            .catch
            (
                error => {
                    console.log(error)
                    vm.openAlertDialog('Ha ocurrido un error para visualizar el documento.', 'btn-danger')
                }
            )
    }


    onEliminarDocumento(idDocumento: any, idAyudaMedica: any) {
        let vm = this

        if (vm.data.documentosAyuda.length == 1) {
            vm.openAlertDialog('No puede eliminar todos los documentos desde la solicitud', 'btn-danger')
            Swal.close();
            return false;
        }

        const dialogRef = this.dialog.open(ConfirmationDialog, {
            data: { message: '¿Esta seguro de eliminar el documento?', buttonText: { ok: 'Si', cancel: 'No' } }
        })

        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                Swal.fire({
                    allowOutsideClick: false,
                    icon: 'info',
                    text: 'Cargando...'
                });
                Swal.showLoading();
                vm.ayudaService.eliminarDocumentoAyudaMedica(idDocumento).then
                    (
                        (response: any) => {
                            //vm.data.mostrarDocumento = false;
                            Swal.close();
                            vm.onActualizarDocumentos(idAyudaMedica, "ELIMINA");
                            vm.openAlertDialog('El documento fue eliminado exitosamente.', 'btn-success')
                            vm.editarAyudaMedicaPostGuardarDocumento();
                        }

                    )
                    .catch
                    (
                        error => {
                            console.log(error)
                            vm.openAlertDialog('Ha ocurrido un error para visualizar el documento.', 'btn-danger')
                        }
                    )
            }
        })
    }
    calculaTotalaPagar(event) {
        let vm = this
        if (vm.data.porcentajeRebaja > 100 || vm.data.porcentajeRebaja < 0) {
            vm.openAlertDialog('El rango de Porcentaje debe ser entre 0 y 100%.', 'btn-danger')
            vm.data.porcentajeRebaja = 0
            Swal.close();
        } else {
            console.log('sumatoriaCupoOcupado:',vm.data.sumatoriaCupoOcupado)
            let PorcentajeRebajado = vm.data.totalCopago - Math.ceil(vm.data.totalCopago * vm.data.porcentajeRebaja / 100)
            vm.data.totalPagar = Math.ceil(PorcentajeRebajado * vm.data.porcentaje)
            vm.data.totalconDescuento=Number(vm.data.topeMaximoMedico) -Number(vm.data.sumatoriaCupoOcupado) 
            if(vm.data.totalPagar> vm.data.totalconDescuento){
               vm.data.totalPagar=vm.data.totalconDescuento
            }
        }

    }
   


    onActualizarDocumentos(idDocumento: any, tipoAccion: string) {
        let vm = this
        let sumatoriaMontoCopago = 0;
        vm.ayudaService.traeDocumentos(idDocumento).then
            (
                (response: any) => {
                    vm.data.documentosAyuda = response
                    this.data.mostrarDocumento = false;
                    vm.data.documentosAyudaEdit.fechaDocumento = response.fechaDocumento
                    let descripcionTipoEvento;
                    for (let i = 0; i < response.length; i++) {
                        for (let j = 0; j < vm.data.eventos.length; j++) {
                            if (response[i].idTipoEvento == vm.data.eventos[j].id) {
                                descripcionTipoEvento = vm.data.eventos[j].descripcion;
                            }
                        }
                    }
                    for (let i = 0; i < response.length; i++) {
                        sumatoriaMontoCopago = Number(sumatoriaMontoCopago) + Number(response[i].montoCopago)
                    }
                    let topeMaximo: number                 

                    if (descripcionTipoEvento == 'DENTAL') {
                        topeMaximo= vm.data.topeMaximoDental
                        vm.data.totalCopago = Number(sumatoriaMontoCopago);
                        vm.data.totalconDescuento = Number(topeMaximo) - Number(vm.data.sumatoriaCupoOcupado)
                        if (vm.data.totalCopago >= vm.data.valorCopago1 && vm.data.totalCopago <= vm.data.valorCopago2) {
                            vm.data.totalPagar = vm.data.totalPagar1
                        } else if (vm.data.totalCopago >= vm.data.valorCopago3) {
                            vm.data.totalPagar = vm.data.totalPagar2
                        } else {
                            vm.data.totalPagar = 0
                        }
                       
                        if (vm.data.totalconDescuento < vm.data.totalPagar){
                            if (vm.data.totalCopago >= vm.data.valorCopago1 && vm.data.totalCopago <= vm.data.valorCopago2) {
                                vm.data.totalPagar = 0
                            }else {
                                vm.data.totalPagar = vm.data.totalconDescuento
                            }
                        }

                    } else {
                        topeMaximo= vm.data.topeMaximoMedico
                        vm.data.totalconDescuento=Number(topeMaximo) -Number(vm.data.sumatoriaCupoOcupado) 
                      
                        /*                          
                            vm.data.totalPagar: 2500000 
                            se agregar porcentaje de rebaja del 30% (0.3) 750.000
                            y a ese millon 1.750.000 se le debe aplicar el 0.35
                            el monto total a pagar serian :612.500
                        */
                        if (vm.data.porcentajeRebaja && vm.data.porcentajeRebaja > 0) {
                            vm.data.totalCopago = Number(sumatoriaMontoCopago);
                            let PorcentajeRebajado = vm.data.totalCopago - Math.ceil(vm.data.totalCopago * vm.data.porcentajeRebaja / 100)
                            vm.data.totalPagar = Math.ceil(PorcentajeRebajado * vm.data.porcentaje)
                          
                        } else {
                            vm.data.totalCopago = Number(sumatoriaMontoCopago);
                            vm.data.totalPagar = Math.ceil(vm.data.totalCopago * vm.data.porcentaje)
                        }
                      
                        if(vm.data.totalPagar> vm.data.totalconDescuento){
                           vm.data.totalPagar=vm.data.totalconDescuento
                        }
                    }
                    if(vm.data.totalPagar>topeMaximo) {
                        this.openAlertDialog('El total no debe super al máximo permitido:'+topeMaximo, 'btn-danger')
                        Swal.close();
                        return false;
                    }
                    vm.openAlertDialog('El documento fue modificado exitosamente.', 'btn-success')
                    vm.editarAyudaMedicaPostGuardarDocumento();
                  
                }
            )
            .catch
            (
                error => {
                    console.log(error)
                    vm.openAlertDialog('Ha ocurrido un error para visualizar el documento.', 'btn-danger')
                }
            )
    }

    onCerrarEditClick() {
        this.data.mostrarDocumento = false;
    }


    onGuardarEditClick(idAyudaMedica: any) {
        let vm = this
        let modificaEvento = false
        for (let i = 0; i < vm.data.documentosAyuda.length; i++) {
            if (vm.data.documentosAyuda[i].idTipoEvento != vm.data.documentosAyudaEdit.idTipoEvento) {
                modificaEvento = true
            }
        }
        if (modificaEvento) {
            const dialogRef = this.dialog.open(ConfirmationDialog, {
                data: { message: '¿Esta seguro de editar el tipo de evento?', buttonText: { ok: 'Si', cancel: 'No' } }
            })

            dialogRef.afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    Swal.fire({
                        allowOutsideClick: false,
                        icon: 'info',
                        text: 'Cargando...'
                    });
                    Swal.showLoading();
                    this.editarDocumento(idAyudaMedica)
                }
            })
        } else {
            this.editarDocumento(idAyudaMedica)
        }

    }

    editarDocumento(idAyudaMedica: any) {
        let descripcionTipoEvento: String
        let idTipoEvento: any
        let idEjecutivo = localStorage.getItem("idUsuario")
        let vm = this
        if (!vm.data.documentosAyudaEdit.sistemaSalud) {
            vm.openAlertDialog('El campo sistema de Salud no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }

        if (!vm.data.documentosAyudaEdit.rutPrestador) {
            this.openAlertDialog('Se debe ingresar el rut prestador', 'btn-danger')
            Swal.close();
            return false;
        }


        if (!Rut(vm.data.documentosAyudaEdit.rutPrestador)) {
            this.openAlertDialog('El RUT tiene un formato incorrecto. Favor Revisar', 'btn-danger')
            Swal.close();
            return false;
        }

        if (!vm.data.documentosAyudaEdit.tipoDocumento) {
            vm.openAlertDialog('El campo tipoDocumento no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }
        if (!vm.data.documentosAyudaEdit.diagnostico) {
            vm.openAlertDialog('El campo diagnostico no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }
        if (!vm.data.documentosAyudaEdit.tratamiento) {
            vm.openAlertDialog('El campo tratamiento no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }

        if (vm.data.documentosAyudaEdit.montoTotalGasto <= 0) {
            vm.openAlertDialog('El campo montoTotalGasto no debe ser 0', 'btn-danger')
            Swal.close();
            return false;
        }

        if (vm.data.documentosAyudaEdit.montoTotalGasto < 0) {
            vm.openAlertDialog('El campo montoTotalGasto debe ser mayor a 0', 'btn-danger')
            Swal.close();
            return false;
        }
        if (vm.data.documentosAyudaEdit.montoReembolso < 0) {
            vm.openAlertDialog('El campo montoReembolso debe ser mayor a 0', 'btn-danger')
            Swal.close();
            return false;
        }
        if (vm.data.documentosAyudaEdit.montoReembolsoSistema < 0) {
            vm.openAlertDialog('El campo montoReembolsoSistema debe ser mayor a 0', 'btn-danger')
            Swal.close();
            return false;
        }

        if (vm.data.documentosAyudaEdit.montoCopago < 0) {
            vm.openAlertDialog('El campo montoCopago debe ser mayor a 0', 'btn-danger')
            Swal.close();
            return false;
        }


        if (!vm.data.documentosAyudaEdit.fechaDocumento) {
            vm.openAlertDialog('El campo fecha Documento no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }

        if (!Rut(vm.data.documentosAyudaEdit.rutPrestador)) {
            this.openAlertDialog('El RUT del prestador tiene un formato incorrecto. Favor Revisar', 'btn-danger')
            Swal.close();
            return false;
        }

        if (!vm.data.documentosAyudaEdit.rutPrestador) {
            vm.openAlertDialog('El campo Rut de prestador no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }

        if (!vm.data.documentosAyudaEdit.nroDocumento) {
            vm.openAlertDialog('El campo Folio de documento no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }

        if (vm.data.documentosAyudaEdit.nroDocumento) {
            for (let i = 0; i < vm.data.documentosAyuda.length; i++) {
                if (vm.data.documentosAyudaEdit.idDocumentoAyudaMedica != vm.data.documentosAyuda[i].idDocumentoAyudaMedica) {
                    if (vm.data.documentosAyuda[i].nroDocumento == vm.data.documentosAyudaEdit.nroDocumento) {
                        vm.openAlertDialog('El campo folio de documento no debe coincidir con el folio de otros documentos', 'btn-danger')
                        Swal.close();
                        return false;
                    }
                }
            }
        }


        let fechaDocumentoTemp = ''
        if (vm.data.documentosAyudaEdit.fechaDocumento) {
            fechaDocumentoTemp = vm.data.documentosAyudaEdit.fechaDocumento.split('-')[2] + '-' + vm.data.documentosAyudaEdit.fechaDocumento.split('-')[1] + '-' +
                vm.data.documentosAyudaEdit.fechaDocumento.split('-')[0]
        } else {
            vm.openAlertDialog('El campo fecha de documento no debe ir vacio', 'btn-danger')
            Swal.close();
            return false;
        }
        if (vm.data.documentosAyudaEdit.fechaDocumento) {
            let DAfechaDocumento = new Date(vm.data.documentosAyudaEdit.fechaDocumento + 'T00:00')
            let fechaMinima = new Date()
            fechaMinima.setDate(fechaMinima.getDate() - vm.data.diasDiferencia)

            if ((DAfechaDocumento < fechaMinima || DAfechaDocumento > new Date())) {
                this.openAlertDialog('La Fecha de solicitud supera la vigencia de 180 dias o excede la fecha actual. Favor revisar.', 'btn-dark')
                Swal.close();
                return false
            }
        }
        for (let i = 0; i < vm.data.eventos.length; i++) {
            if (vm.data.eventos[i].id == vm.data.tipoEvento) {
                descripcionTipoEvento = vm.data.eventos[i].descripcion;
                idTipoEvento = vm.data.eventos[i].id;
            }
        }

        let fechaDocumento = vm.data.documentosAyudaEdit.fechaDocumento.split('-')[2] + '-' + vm.data.documentosAyudaEdit.fechaDocumento.split('-')[1] + '-' +
            vm.data.documentosAyudaEdit.fechaDocumento.split('-')[0]

        let rutPrestador = vm.data.documentosAyudaEdit.rutPrestador.split('-')[0];
        let dvPrestador = vm.data.documentosAyudaEdit.rutPrestador.split('-')[1];

        if (!this.data.otroProteccionSalud) {
            vm.data.documentosAyudaEdit.otroProteccion = ''
        }
        if (!this.data.otro) {
            vm.data.documentosAyudaEdit.otroSistemaSalud = ''
        }
 
        this.editarDocumentoAyudaMedica(idAyudaMedica,fechaDocumento,rutPrestador,dvPrestador,idEjecutivo)


    }

    editarDocumentoAyudaMedica(idAyudaMedica: any,fechaDocumento: any,rutPrestador: any,dvPrestador: any,idEjecutivo: any) {
        let vm = this
        this.ayudaService.editarDocumentoAyudaMedica(vm.data.documentosAyudaEdit, fechaDocumento, rutPrestador, dvPrestador, vm.data.idUsuario, vm.data.idCarga, idEjecutivo).then
            (
                () => {

                    vm.data.mostrarDocumento = false;
                    Swal.close();
                    vm.onActualizarDocumentos(idAyudaMedica, "EDITA");
                  
                   // vm.editarAyudaMedicaPostGuardarDocumento();
                }
            )
            .catch
            (
                (error: any) => {

                    if (error.status == 402) {
                        vm.openAlertDialog('Documento emitido en periodo de carencia.', 'btn-danger')
                        Swal.close();
                    } else if (error.status == 412) {
                        vm.openAlertDialog('Beneficio con fecha de evento anterior a la fecha de afiliación.', 'btn-danger')
                        Swal.close();
                    } else if (error.status == 406) {
                        vm.openAlertDialog('El rut del hijo ya se encuentra asociado al afiliado.', 'btn-danger')
                        Swal.close();
                    } else if (error.status == 423) {
                        vm.openAlertDialog('Ya existe una solicitud para el rut prestador y el num. documento.', 'btn-danger')
                        Swal.close();
                    } else {
                        vm.dialogRef.close()
                        Swal.close();
                        vm.openAlertDialog('La postulación no se ha logrado guardar.', 'btn-danger')
                    }
                }
            )

    }

    numberOnly(event): boolean {
        const charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }


    openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }


    validateFormat(event) {
        let key;
        if (event.type === 'paste') {
            key = event.clipboardData.getData('text/plain');
        } else {
            key = event.keyCode;
            key = String.fromCharCode(key);
        }
        const regex = /[0-9]|\./;
        if (!regex.test(key)) {
            event.returnValue = false;
            if (event.preventDefault) {
                event.preventDefault();
            }
        }
    }

    muestraOtro() {
        let vm = this
        this.data.otro = false;
        vm.data.tipoSistema = 0
        for (let i = 0; i < this.data.sistema.length; i++) {

            if (vm.data.sistema[i].descripcion == 'OTRO') {
                vm.data.tipoSistema = this.data.sistema[i].id;
            } else {
                vm.data.tipoSistema = 0
            }
        }

        if (this.data.documentosAyudaEdit.sistemaSalud == vm.data.tipoSistema) {
            this.data.otro = true;
        }

    }

    calculaMontoCopago() {
        this.data.documentosAyudaEdit.montoCopago = (this.data.documentosAyudaEdit.montoTotalGasto - (this.data.documentosAyudaEdit.montoReembolso + this.data.documentosAyudaEdit.montoReembolsoSistema + this.data.documentosAyudaEdit.montoOtroReembolso));
    }



    muestraOtroProteccionSalud() {
        let vm = this
        vm.data.otroProteccionSalud = false;
        vm.data.tipoProteccion = 0

        for (let i = 0; i < vm.data.proteccion.length; i++) {
            if (vm.data.proteccion[i].descripcion == 'Otro') {

                vm.data.tipoProteccion = vm.data.proteccion[i].id;
            }
        }
        for (let j = 0; j < vm.data.documentosAyudaEdit.proteccionSaludArray.length; j++) {
            if (vm.data.documentosAyudaEdit.proteccionSaludArray[j] == vm.data.tipoProteccion) {
                vm.data.otroProteccionSalud = true;
            }
        }
        vm.limpiarOpcionNinguno()
    }

    limpiarOpcionNinguno() {
        let vm = this
        vm.data.tipoProteccion = 0
        vm.data.IdOpcionNinguna = 34
        for (let i = 0; i < vm.data.proteccion.length; i++) {
            if (vm.data.proteccion[i].descripcion == 'Ninguno') {
                vm.data.IdOpcionNinguna = this.data.proteccion[i].id;
            }
        }
        for (let j = 0; j < vm.data.documentosAyudaEdit.proteccionSaludArray.length; j++) {
            if (vm.data.documentosAyudaEdit.proteccionSaludArray[j] == vm.data.IdOpcionNinguna) {
                let arrayOpciones: Array<number> = []
                arrayOpciones.push(vm.data.IdOpcionNinguna);
                this.data.otroProteccionSalud = false;
                vm.data.documentosAyudaEdit.proteccionSaludArray = arrayOpciones;
            }
        }
    }


    sumaArchivo() {
        if (this.data.cantidadArchivos <= 6) {

            this.data.cantidadArchivos = this.data.cantidadArchivos + 1
        }
    }


    restaArchivo() {
        this.data.cantidadArchivos = this.data.cantidadArchivos - 1
        this.data.archivo.splice(this.data.cantidadArchivos, 1);
    }

    seleccionaArchivo(event: any, numero: number) {
        if (event.target.files.length > 0) {
            console.log(event.target.files[0].type)

            let vm = this
            let reader = new FileReader()
            this.data.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
            reader.readAsDataURL(event.target.files[0])

            reader.onload = function () {
                vm.data.archivo[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }
            }
        }
    }
}